import { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Menu } from "lucide-react";
import Cookies from "js-cookie";
import { CompanyLogoutAPI } from "../../Auth/Services/AuthService";
import { useUser } from "../../../Utility/userContext";

export default function Header({
  subtitle = "Here's an overview of your assessments and candidate progress.",
  notificationCount = 5,
}) {
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);
  const navigate = useNavigate();
  const { user, refreshUser } = useUser();
  const userName = user?.userName || "HR User";
  const userInitial = user?.userName?.[0]?.toUpperCase() ?? "H";
  const title = `Welcome, ${userName}! 👋`;

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleLogout = async () => {
    try {
      await CompanyLogoutAPI();
    } catch (error) {
    } finally {
      Cookies.remove("JWTToken");
      Cookies.remove("userID");
      Cookies.remove("userRole");
      Cookies.remove("tokenExpiry");
      setMenuOpen(false);
      refreshUser();
      navigate("/CompanyLogin");
      CustomToast("success", "Logout Successfully.");
    }
  };

  return (
    <header className="flex items-start justify-between gap-4 mb-2 p-4">
      <div>
        <h1 className="text-2xl font-bold text-slate-900">{title}</h1>
        <p className="text-sm text-gray-500 mt-1">{subtitle}</p>
      </div>

      <div className="flex items-center gap-5 shrink-0">
        <div className="relative" ref={menuRef}>
          <button
            type="button"
            onClick={() => setMenuOpen((prev) => !prev)}
            className="flex items-center gap-3 bg-gray-50 hover:bg-gray-100 border border-gray-200 rounded-full py-1.5 pl-1.5 pr-3 transition-colors"
            aria-label="User menu"
            aria-expanded={menuOpen}
            aria-haspopup="true"
          >
            <div className="w-9 h-9 rounded-full bg-gradient-to-br from-[#7f35b2] to-[#48086f] text-white font-bold text-sm flex items-center justify-center shrink-0">
              {userInitial}
            </div>
            <span className="hidden sm:block text-sm font-semibold text-gray-700 whitespace-nowrap">
              {userName}
            </span>
            <Menu className="w-[18px] h-[18px] text-gray-600 shrink-0" strokeWidth={2} />
          </button>

          {menuOpen && (
            <div className="absolute right-0 mt-2 w-44 rounded-xl border border-gray-100 bg-white py-1 shadow-lg ring-1 ring-black/5 animate-[fadeIn_150ms_ease] z-50">
              <button
                onClick={handleLogout}
                className="flex w-full items-center gap-2 px-4 py-2.5 text-sm text-gray-700 transition-colors hover:bg-red-50 hover:text-red-600"
              >
                <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a2 2 0 01-2 2H6a2 2 0 01-2-2V7a2 2 0 012-2h5a2 2 0 012 2v1"
                  />
                </svg>
                Logout
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}
